const navbarItems = [
    {
      title: "About",
      link: "/about",
    },
    {
      title: "Services",
      link: "/services",
    },
    
  ];
  
  export default navbarItems;